(ns motorsaif.web.forms.request
  (:require
   [motorsaif.web.forms.car :as car-form]
   [motorsaif.web.lib.form :as form]
   [motorsaif.i18n :as i18n :refer [tr]]
   [reagent.core :as r]
   [motorsaif.web.components :as c]
   [re-frame.core :as rf :refer [dispatch subscribe]]))


;; TODO: General form error when validation fails
;;
;;
;; Form values should be accessible in db
;; Set path

;; (defn fullscreen-gallery [id idx]
;;   (let [*refs (r/atom [])
;;         *gallery-ref (atom nil)]
;;     (r/create-class
;;       {:component-did-mount (fn []
;;                               (.fullScreen @*gallery-ref)
;;                               (.slideToIndex @*gallery-ref (dec idx)))
;;        :reagent-render
;;        (fn []
;;          (let [*space (subscribe [:space id])
;;                {:bookable/keys [media]} @*space
;;                media (sort-by :media/order media)
;;                title "d"
;;                ]
;;            [:div#fs-gallery
;;             [:a.close
;;              ;; Should conditionally either pop history stack if exists or navigate.
;;              #_{:href
;;               (routes/path-for :sid-space-title {:short-id (:short/id @*space)
;;                                                  :title (c-listing/space->url-title @*space)})}
;;              [:i.fas.fa-times]]
;;             [:> react-gallery
;;              {:ref #(reset! *gallery-ref %)
;;               :showPlayButton false
;;               :slideDuration 240
;;               :showFullscreenButton false
;;               :onScreenChange (fn [e]
;;                                 ;; FS close, go to the space
;;                                 (when-not e
;;                                   (dispatch [:common/navigate! :sid-space-title
;;                                              {:short-id (:short/id @*space)
;;                                               :title title}])))
;;               :onSlide (fn [idx]
;;                          (dispatch [:common/replace-state! :sid-space-full-photos
;;                                     {:short-id (:short/id @*space)
;;                                      :idx (inc idx) :title title}]))
;;               :useBrowserFullscreen false
;;               :items
;;               (clj->js (mapv (fn [itm]
;;                                {:original (utils/uploaded-img-src itm)
;;                                 :thumbnail (utils/uploaded-img-src itm)})
;;                              media))}]]))})))

#_(defn location [{:keys [set-val radio]}]
    [:div.form-section
     [:h3 "Location"]
     [radio
      (mapv (fn [{id :db/id
                  loc-name :location/name}]
              {:title loc-name
               :value id})
            @(subscribe [:locations]))
      {:class "horizontal small"}
      [:request :request/location]]])

(defn- upgrade-form [{:keys [presentable-error input uploader uploaded-media radio get-val retract-fn]}]
  (let [*tags (subscribe [:tags])]
    (fn []
      [:div#repairs.form-section
       (let [path [:request :request/category]]
         [:section

          [:h3 (tr :forms.request.upgrade.category/title)]
          [:p (tr :forms.request.upgrade.category/description)]

          [:div.input-wrap
           [radio
            (mapv (fn [{id :db/id
                        title :tag/title}]
                    {:title title
                     :value id})
                  @*tags)
            {:class "horizontal small"}
            path]]])
       [:section
        [:h3 (tr :forms.request.upgrade.textarea/title)]
        [:p (tr :forms.request.upgrade.textarea/description)]
        [input {:type :textarea
                :rows 4
                :placeholder (tr :forms.request.upgrade.textarea/placeholder)
                :limit 400}
         [:request :request/description]]]])))

(defn- repair-form [{:keys [input uploader uploaded-media radio get-val retract-fn]}]
  (let [*tags (subscribe [:tags])]
    (fn []
      [:div#repairs.form-section
       [:section.category
        [:h3 (tr :forms.request.repair.category/title)]
        [:p (tr :forms.request.repair.category/description)]
        [radio
         (mapv (fn [{id :db/id
                     title :tag/title}]
                 {:title title
                  :value id})
               @*tags)
         {:class "horizontal small"}
         [:request :request/category]]]

       [:section.description
        [:h3 (tr :forms.request.repair.textarea/title)]
        [:p (tr :forms.request.repair.textarea/description)]
        [input {:type :textarea
                :rows 4
                :placeholder (tr :forms.request.repair.textarea/placeholder)
                :limit 400}
         [:request :request/description]]]])))


(defn part-form [{:keys [input uploader uploaded-media radio get-val retract-fn]}]
  ;; (def ah get-val)
  ;; (ah [:request :request/category])
  ;; (ah [:request :part/condition])
  ;; (get-val )
  (let [*tags (subscribe [:tags])]
    (fn []
      [:div#parts.form-section
       [:section.category
        [:h3 (tr :forms.request.part.category/title)]
        [:p (tr :forms.request.part.category/description)]
        [radio
         (mapv (fn [{id :db/id
                     title :tag/title}]
                 {:title title
                  :value id})
               @*tags)
         {:class "horizontal small"}
         [:request :request/category]]]

       [:section.description
        [:h3 (tr :forms.request.part.textarea/title)]
        [:p (tr :forms.request.part.textarea/description)]
        [input {:type :textarea
                :rows 4
                :placeholder (tr :forms.request.part.textarea/placeholder)
                :limit 400}
         [:request :request/description]]]
       [:section.condition
        [:h3 (tr :forms.request.part.condition/title)]
        [:p (tr :forms.request.part.condition/description)]
        [radio
         (mapv (fn [[id title]]
                 {:title title
                  :value id})
               [[:new (tr :domain.part-condition/new)]
                [:used (tr :domain.part-condition/used)]
                [:either (tr :domain.part-condition/either)]])
         {:class "horizontal small"}
         [:request :part/condition]]]])))

(defn posting-as [{:keys [select get-val] :as form}]
  (let [user @(subscribe [:user])
        roles @(subscribe [:business-roles])
        select-data (concat
                     [{:title (tr [:forms.request.posting-as/personal] [(:user/handle user)])
                       :value (:db/id user)}]
                     (mapv (fn [[_ {id :db/id
                                    biz-name :business/name}]]
                             {:title
                              (tr [:forms.request.posting-as/business] [biz-name])
                              :value id}) roles))]
    [:div [:h3 (tr :forms.request.posting-as/title)]
     [select {:data select-data}
      [:request :request/owner]]]))

(defn upload-media-form [{:keys [input uploader uploaded-media radio get-val retract-fn]}]
  (let [media-path [:request :request/media]]
    [:section#upload-media
     [:h3 (tr :forms.request.media/title)]
     [:p (tr :forms.request.media/description)]
     [:div.full-upload-wrapper
      [uploaded-media
       {:after-remove
        (fn [{id :db/id :as itm}]
          (let [parent-id (get-val [:request :db/id])]
            (retract-fn {:parent-id parent-id
                         :key :request/media
                         :item-id id})))}
       media-path]
      [uploader media-path
       {:file-limit 5}]]]))

(defn location-input [{:keys [get-val set-val presentable-error] :as form}]
  (let [path [:request :request/coords]
        default-coords (get-val path)
        on-pos-change (fn [{:keys [geocode lon lat]}]
                        (set-val [:request :request/geo-location] (get-in (js->clj geocode) ["results" 0 "formatted_address"]))
                        (set-val path [lon lat]))]
    [:section.geo-location-wrapper
     [:h3 (tr :forms.request.location/title)]
     [:p.helper.italic (tr :forms.request.location/description)]
     [:div.gps-location
      (when-let [error (presentable-error path)]
        error)
      [c/gps-location {:on-pos-change on-pos-change
                       :default-coords default-coords}]]
     [(fn []
        [:div.geo-location
         (or (get-val [:request :request/geo-location])
             (tr :forms.request.location/drop-pin))])]]))

(defn request-category [{:keys [set-val get-val]}]
  [:div.request-category
   [:h3 (tr :forms.request/request-type)]
   [:p (tr :forms.request/choose-request-type)]
   (into [:ul]
         (map (fn [[title desc icon kw]]
                [:li.request-category
                 {:on-click #(set-val [:request :request/type] kw)
                  :class (when
                             (= (get-val [:request :request/type]) kw)
                           "active")}
                 [:div.left icon]
                 [:div.right
                  [:div.title title]
                  [:div.desc desc]]])
              [[(tr :categories/repairs)
                "Any problem and issues"
                [:i.fas.fa-wrench]
                :repair]
               [(tr :categories/modifications)
                "Tuning and upgrades"
                [:i.fas.fa-sparkles]
                :upgrade]
               [(tr :categories/parts)
                "New and used parts"
                [:i.fas.fa-gears]
                :part]]))])

(defn form [{:keys [form-key make-form-args]}]
  (let [{:keys [get-val form-params] :as form}
        (form/make-form make-form-args)]
    (fn []
      (let [chosen-category (get-val [:request :request/type])]
        [:form.default.request
         form-params
         [:div
          [request-category form]]
         (when (get-val [:request :request/type])
           [:div
            [:section
             [car-form/car-form {:form form}]]
            (condp = chosen-category
              :part [part-form form]
              :repair [repair-form form]
              :upgrade [upgrade-form form])
            [upload-media-form form]
            [location-input form]
            [:button.btn.primary.full
             {:type "submit"}
             (condp = form-key
               :new-request (tr :forms.general/create)
               :edit-request (tr :forms.general/save))]])]))))

(comment
  (subscribe [:ajax-status :bootstrap-data])
  (dispatch [:reset-form :request nil]))
;; Org need?
